import api from './api';
import axios from 'axios';

/**
 * Contract Service - API calls for contract management
 */

// Contract Templates
export const getContractTemplates = () => {
  return api.get('/contracts/templates');
};

export const getContractTemplate = (templateId) => {
  return api.get(`/contracts/templates/${templateId}`);
};

export const createContractTemplate = (templateData) => {
  return api.post('/contracts/templates', templateData);
};

export const updateContractTemplate = (templateId, templateData) => {
  return api.put(`/contracts/templates/${templateId}`, templateData);
};

export const deleteContractTemplate = (templateId) => {
  return api.delete(`/contracts/templates/${templateId}`);
};

// Contracts
export const getContracts = (params = {}) => {
  return api.get('/contracts/', { params });
};

export const getContract = (contractId) => {
  return api.get(`/contracts/${contractId}`);
};

export const createContract = (contractData) => {
  return api.post('/contracts/', contractData);
};

export const updateContract = (contractId, contractData) => {
  return api.put(`/contracts/${contractId}`, contractData);
};

export const deleteContract = (contractId) => {
  return api.delete(`/contracts/${contractId}`);
};

// Contract Generation
export const generateContract = (generationData) => {
  return api.post('/contracts/generate', generationData);
};

// Contract Signing
export const sendContract = (contractId, signerData) => {
  return api.post(`/contracts/${contractId}/send`, signerData);
};

export const getContractByToken = (token) => {
  // Public endpoint - no auth needed
  return axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8000/api',
  }).get(`/contracts/sign/${token}`);
};

export const signContract = (contractId, signatureData) => {
  // Public endpoint - no auth needed
  return axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8000/api',
  }).post(`/contracts/${contractId}/sign`, signatureData);
};

// Contract PDF & Verification
export const downloadContractPDF = (contractId) => {
  return api.get(`/contracts/${contractId}/pdf`, {
    responseType: 'blob'
  });
};

export const verifySignature = (contractId) => {
  return api.get(`/contracts/${contractId}/verify`);
};

// Contract Stats
export const getContractStats = () => {
  return api.get('/contracts/stats');
};

export default {
  // Templates
  getContractTemplates,
  getContractTemplate,
  createContractTemplate,
  updateContractTemplate,
  deleteContractTemplate,

  // Contracts
  getContracts,
  getContract,
  createContract,
  updateContract,
  deleteContract,

  // Operations
  generateContract,
  sendContract,
  getContractByToken,
  signContract,
  downloadContractPDF,
  verifySignature,
  getContractStats
};
